<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">资格审核</h4>
      </div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
        <div class="title-little-subheading">
          处置公告要素
        </div>
        <div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞价开始时间:">
                <span>{{ ruleForm.bidStartTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购买资格审核:">
                <span>{{
                  ruleForm.enrollExamine == 0 ? '无需资质审核' : '资格审核'
                }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-form-item label="是否允许联合体受让:">
            <span>{{ ruleForm.jointWhether == 1 ? '是' : '否' }}</span>
          </el-form-item> -->
        </div>
        <div class="title-little-subheading">
          本场竞买须知
        </div>
        <el-form-item label="本场竞买须知:">
          <span>{{ ruleForm.instructions }}</span>
        </el-form-item>
      </el-form>
      <div class="title-little-subheading">
        竞买报名信息
      </div>
      <div>
        <el-form :model="formself" ref="formself" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞买人:">
                <span>{{ formself.compName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报名时间:">
                <span>{{ formself.submitTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="注册资金(元):">
                <span>{{ formself.registerAmount | numberFormat(2) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地:">
                <span>{{ formself.straddrEc }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="报名说明:">
                <span>{{ formself.remark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="报名附件:">
                <div
                  v-for="(item, index) in formself.enroollFileList"
                  :key="index"
                >
                  <a
                    href="javascript:;"
                    @click="onDownload(item)"
                    class="attachment"
                  >
                    {{ item.fileName }}
                  </a>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="是否联合体:" v-if="ruleForm.jointWhether == 1">
            <span>{{ formself.jointWhether == 1 ? '是' : '否' }}</span>
          </el-form-item>
          <el-form-item
            label="联合公司名称:"
            v-if="ruleForm.jointWhether == 1 && formself.jointWhether == 1"
          >
            <span>{{ formself.jointCompName }}</span>
          </el-form-item>
          <el-table
            border
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            class="table"
          >
            <el-table-column
              label="序号"
              type="index"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column label="证照名称" align="center">
              <template slot-scope="scope">{{
                scope.row.licenceName
              }}</template>
            </el-table-column>

            <el-table-column
              prop="licenceEndDate"
              label="证照有效期至"
              width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="fileName" label="扫描件" align="center">
              <template slot-scope="scope">
                <span class="cell-link" @click="link(scope.row)">
                  {{ scope.row.fileName }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人:">
                <span>{{ formself.contName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话:">
                <span>{{ formself.contPhone }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机:">
                <span>{{ formself.contMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱:">
                <span>{{ formself.contEmail }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="传真:">
                <span>{{ formself.contFax }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他联系方式:">
                <span>{{ formself.contOtherWay }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="title-little-subheading">
        审核
      </div>
      <div>
        <el-form :model="formAudit" ref="formAudit" label-width="150px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="复审结果:" v-if="typequery == 1">
                <span>{{
                  formAudit.confirmStatus == 3
                    ? '不通过'
                    : formAudit.confirmStatus == 2
                    ? '通过'
                    : ''
                }}</span>
              </el-form-item>
              <el-form-item
                label="复审结果:"
                :rules="[
                  {
                    required: true,
                    message: '请选择复审结果',
                    trigger: 'change'
                  }
                ]"
                prop="auditWhether"
                v-else
              >
                <el-radio v-model="formAudit.auditWhether" :label="1"
                  >通过</el-radio
                >
                <el-radio v-model="formAudit.auditWhether" :label="2"
                  >不通过</el-radio
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="说明:"
            prop="auditRemark"
            :rules="
              formAudit.auditWhether == 2
                ? [
                    {
                      required: true,
                      message: ' ',
                      trigger: 'blur',
                      pattern: '[^ \x20]'
                    }
                  ]
                : []
            "
          >
            <span v-if="typequery == 1">{{ formAudit.confirmRemark }}</span>
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="formAudit.auditRemark"
              maxlength="200"
              show-word-limit
              v-else
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div v-if="typequery">
          <div class="title-little-subheading">
            审批记录
          </div>
          <div class="titlepen">
            <confimTable :tableData="auditList"></confimTable>
          </div>
          <div>
            <div class="title-little-subheading">
              复审记录
            </div>
            <div class="titlepen">
              <confimTableRepeat :tableData="reexamineList"></confimTableRepeat>
            </div>
          </div>
        </div>
      </div>

      <div class="page-index-footer">
        <el-button @click="submit" type="primary" v-if="typequery != 1"
          >确定</el-button
        >
        <el-button @click="down">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import confimTable from './components/confimTable'
import confimTableRepeat from './components/confimTableRepeat'
export default {
  components: {
    confimTable,
    confimTableRepeat
  },
  data() {
    return {
      auditList: [],
      reexamineList: [],
      formAudit: {
        auditRemark: '',
        auditWhether: null,
        fileList: []
      },
      number: '0',
      formself: {},
      form: {
        auditRemark: ''
      },
      ruleForm: {
        title: '',
        code: '',
        bidStartTime: '',
        instructions: ''
      },
      tableData: [],
      multipleSelection: [],
      dialogTableVisible: false,
      choose: ''
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    },
    noticeID() {
      return this.$route.query.noticeID
    },
    typequery() {
      return this.$route.query.typequery
    }
  },
  created() {
    this.noticeGet()

    this.enroolllist()
    this.listLicence()
    if (this.typequery == 1) {
      this.listRecord()
      this.listRecord1()
    }
  },
  methods: {
    noticeFiles(val) {
      this.formAudit.fileList = val
    },
    async listLicence() {
      let data = await this.$api.materialdisposal.listLicence({
        id: this.typeId
      })
      this.tableData = data.data
      //   this.formself = data
    },
    async enroolllist() {
      let data = await this.$api.materialdisposal.enroolllist({
        id: this.typeId
      })
      if (data.auditWhether == 0) {
        data.auditWhether = null
        data.auditRemark = ''
        data.enroollAuditFileList = []
      }
      this.formself = data
      this.formAudit = {
        ...this.formAudit,
        ...data
      }
    },
    async noticeGet() {
      let data = await this.$api.materialdisposal.noticeGet({
        id: this.noticeID
      })
      this.ruleForm = data
    },
    async submit() {
      this.$refs.formAudit.validate(async valid => {
        if (valid) {
          let query = {
            id: this.typeId,
            ...this.formAudit
          }
          let data = await this.$api.serviceProvider.auditEntrustEnrooll(query)
          if (data) {
            this.$message.success('提交成功')
            this.$router.go(-1)
          }
        }
      })
    },
    async link(o) {
      if (o.licenceFrom == 1) {
        window.open(o.fileWebpath)
      } else {
        let res = await this.$api.common.downloadFile(o.fileId)
        let blob = new Blob([res])
        let fileName = o.fileName
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    },
    async listRecord() {
      let data = await this.$api.serviceProvider.listRecord({
        auditType: 1,
        enroollId: this.$route.query.id
      })
      this.auditList = data.data
    },
    async listRecord1() {
      let data = await this.$api.serviceProvider.listRecord({
        auditType: 2,
        enroollId: this.$route.query.id
      })
      this.reexamineList = data.data
    },
    down() {
      this.$router.go(-1)
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.form {
  padding-right: 50px;
  padding-left: 70px;
}
.instructions {
  min-height: 120px;
  line-height: 20px;
  margin-left: 60px;
}
.titlepen {
  padding-left: 50px;
}
.titlepenleft {
  margin-left: 10px;
}
.titlepenright {
  float: right;
}
.down {
  margin-left: 500px;
  margin-bottom: 20px;
}
.table {
  margin-bottom: 20px;
}
</style>
